import React, { useContext, useEffect, useState } from "react";
import sanitizeHtml from "sanitize-html";
import ReactHtmlParser from "react-html-parser";
import { BsQrCode } from "react-icons/bs";
import { GrEdit } from "react-icons/gr";
import { useHistory } from "react-router-dom";
import { MdOutlineClose } from "react-icons/md";
import { FaList } from "react-icons/fa";
import { validateURL } from "../../../../common";
import { RiDeleteBin5Line } from "react-icons/ri";
import { HiOutlineUsers } from "react-icons/hi2";
import { getCookie } from "../../../../helpers/Cookie";
import { useAuth } from "../../../../authentication";
import {
  Button,
  Card,
  Table,
  Input,
  Modal,
  Tooltip,
  message,
  Row,
  Col,
} from "antd";
import { ClientContextApi } from "../../../../contextApi/ClientContext";
import ClientsAPI from "../../../../services/Clients/Clients";
import useDebounce from "./debounce";
import QRCode from "react-qr-code";
import "./style.css";

const { Search } = Input;
const ClientsApi = new ClientsAPI();

const ClientData = () => {
  // Context API content
  const {
    clientData,
    clientCount,
    updateClientState,
    updateClientCount,
    deleteClientData,
    newClientCount,
    deletedClientCount,
    setAllOffsetState,
    allOffset,
  } = useContext(ClientContextApi);

  const { authUser } = useAuth();
  const clientAdminId = getCookie("clientId");
  const [searchClientData, setSearchClientData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchClientDataCount, setSearchClientDataCount] = useState(0);
  const [tableLoading, setTabelLoading] = useState(false);
  const [previewQRCode, setPreviewQRCode] = useState({
    visible: false,
    clientName: "",
    branchName: "",
    qrcodeId: "",
  });
  const [searchText, setSearchText] = useState("");
  const [searchDisplayText, setSearchDisplayText] = useState("");
  const history = useHistory();

  const handleAddClient = () => {
    history.push("/clients/addClient");
  };

  const handleEdit = (id) => {
    const editUrl = `/clients/updateClient/${id}`;
    history.push(editUrl);
  };

  const handleViewAssets = (id) => {
    const viewAssetsUrl = `/assets/allAssets/${id}`;
    history.push(viewAssetsUrl);
  };

  const handleViewUsers = (id) => {
    const viewUserstUrl = `/users/allUsers/${id}`;
    history.push(viewUserstUrl);
  };

  const showQRCode = async (id, className, branchName) => {
    let tempPreviewQRCode = previewQRCode;
    tempPreviewQRCode = {
      visible: true,
      clientName: className,
      branchName: branchName,
      qrcodeId: id,
    };
    setPreviewQRCode(tempPreviewQRCode);
  };

  const handleClosePreview = () => {
    let tempPreviewQRCode = previewQRCode;
    tempPreviewQRCode = {
      visible: false,
      clientName: "",
      branchName: "",
      qrcodeId: "id",
    };
    setPreviewQRCode(tempPreviewQRCode);
  };

  // Get client count
  const getClientCount = async (searchValue) => {
    try {
      const payload = {
        search: searchValue.trim() || "",
        count: true,
      };

      const response = await ClientsApi.getClientList(payload);
      if (response.data) {
        if (searchValue) {
          setSearchClientDataCount(response.data[0].count);
        } else {
          updateClientCount(response.data[0].count);
        }
      }
    } catch (error) {
      console.error("Error fetching total item count: ", error);
    }
  };

  // Get Client List
  const getClientList = async (searchValue, offsetValue, page) => {
    try {
      setTabelLoading(true);
      const payload = {
        offset: offsetValue,
        search: searchValue.trim() || "",
        count: false,
      };

      const response = await ClientsApi.getClientList(payload);
      if (response) {
        if (searchValue) {
          setSearchClientData(response.data);
        } else {
          updateClientState(response.data, page);
        }
      }

      setTabelLoading(false);
    } catch (error) {
      setTabelLoading(false);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 1000);

  useEffect(() => {
    if (
      !Object.keys(clientData).length > 0 ||
      (debouncedSearchText && debouncedSearchText.length > 2)
    ) {
      getClientCount(debouncedSearchText);
      getClientList(debouncedSearchText, 0, 1);
    }
    //eslint-disable-next-line
  }, [debouncedSearchText]);

  // search clients
  const searchClients = (searchValue) => {
    if (searchValue.trim() !== "") {
      const regex = /(<([^>]+)>)/gi;
      const regex1 = /[\]}[{]/gi;
      let tempSearchValue = sanitizeHtml(searchValue)
        .replace(regex, "")
        .replace(regex1, "");
      if (tempSearchValue !== "") {
        setSearchText(tempSearchValue);
        tempSearchValue = ReactHtmlParser(tempSearchValue);
        setSearchDisplayText(tempSearchValue[0]);
      } else {
        setSearchText("");
        setSearchDisplayText("");
        message.error(
          "Invalid data. Please put valid data in the search fields.",
        );
      }
    } else {
      setSearchText("");
      setSearchDisplayText("");
    }
  };

  // Pagination
  const handlePagination = (page, pageSize) => {
    let newOffset = (page - 1) * pageSize;
    const filterOffset =
      searchText !== ""
        ? undefined
        : allOffset.find((item) => parseInt(item) === newOffset);

    if (filterOffset === undefined) {
      // check new client is added if yes then increase offset count
      if (newClientCount > 0) {
        newOffset = newOffset + newClientCount;
      }

      // check client is deleted if yes then decrease offset count
      if (deletedClientCount > 0) {
        newOffset = newOffset - deletedClientCount;
      }

      setAllOffsetState(newOffset);
      getClientList(debouncedSearchText, newOffset, page);
    }
    setCurrentPage(page);
  };

  const deleteClient = async (recordData) => {
    try {
      const payload = {
        updatedDttm: new Date().getTime(),
      };

      const response = await ClientsApi.deleteClient(
        recordData.clientId,
        payload,
      );
      if (response.status === 200) {
        message.success("Client has been deleted successfully.");
        // const tempClientData = [...clientData];
        // const index = tempClientData.findIndex((x) => x.id === recordData.id);
        // if(index >= 0) {
        //   tempClientData.splice(index, 1);
        //   deleteClientData(tempClientData);

        //   // set deleted client count
        //   setDeletedClientCount(deletedClientCount + 1);
        //   updateClientCount(clientCount - 1);
        // }

        // of seaarch data is present
        if (searchClientDataCount > 0) {
          const tempSearchClientData = [...searchClientData];
          const searchindex = tempSearchClientData.findIndex(
            (x) => x.id === recordData.id,
          );
          if (searchindex >= 0) {
            tempSearchClientData.splice(searchindex, 1);
            setSearchClientData(tempSearchClientData);
            setSearchClientDataCount(searchClientDataCount - 1);
          }
        } else {
          setCurrentPage(1);
          deleteClientData();
          getClientCount(debouncedSearchText);
          getClientList(debouncedSearchText, 0, 1);
        }

        // let tempPageSize = pageSize;
        // tempPageSize--;
        // setpageSize(tempPageSize);
      } else {
        message.error("Something went wrong, please try again later.");
      }
    } catch (error) {
      message.error("Something went wrong, please try again later.");
    }
  };

  // delete confirmation
  const deleteConfirmation = async (recordData) => {
    Modal.confirm({
      title: "Delete Client",
      content: (
        <span>
          Are you sure you want to delete <b>{recordData.clientName}</b> client?
        </span>
      ),
      okText: "Yes",
      cancelText: "No",
      onOk() {
        deleteClient(recordData);
      },
    });
  };

  // Table columns
  const columns = [
    {
      title: "Client Name",
      align: "center",
      dataIndex: "clientName",
      width: 250,
      render: (text) => {
        let clientname = ReactHtmlParser(text);
        if (clientname[0].length > 80) {
          clientname = clientname[0].slice(0, 80) + "...";
        } else {
          clientname = clientname[0];
        }
        return <span dangerouslySetInnerHTML={{ __html: clientname }} />;
      },
    },
    {
      title: "Branch Name",
      align: "center",
      dataIndex: "name",
      width: 250,
      render: (text) => {
        let clientBranch = ReactHtmlParser(text);
        if (clientBranch[0].length > 80) {
          clientBranch = clientBranch[0].slice(0, 80) + "...";
        } else {
          clientBranch = clientBranch[0];
        }
        return <span dangerouslySetInnerHTML={{ __html: clientBranch }} />;
      },
    },
    {
      title: "Description",
      align: "center",
      dataIndex: "description",
      width: 310,
      render: (text) => {
        let clientDesc = ReactHtmlParser(text);
        if (clientDesc[0].length > 100) {
          clientDesc = clientDesc[0].slice(0, 100) + "...";
        } else {
          clientDesc = clientDesc[0];
        }
        return <span dangerouslySetInnerHTML={{ __html: clientDesc }} />;
      },
    },
    {
      title: "Logo",
      align: "center",
      dataIndex: "logoSmallUrl",
      width: 70,
      render: (url) =>
        url ? (
          <div className="branch-logo">
            <img src={validateURL(url) ? url : ""} alt="Logo" />
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "Action",
      align: "center",
      className: "client-list-action",
      width: 180,
      render: (text, record) => (
        <div className="list-action" style={{ minWidth: "150px" }}>
          <Tooltip title="Edit">
            <GrEdit onClick={() => handleEdit(record.clientId)} />
          </Tooltip>

          {authUser.clientId === null || authUser.role === "corporateAdmin" ? (
            <Tooltip title="View Assets">
              <FaList onClick={() => handleViewAssets(record.clientId)} />
            </Tooltip>
          ) : ""}

          {authUser.clientId === null || authUser.role === "corporateAdmin" ? (
            <Tooltip title={"View Users (" + record.usersCount + ")"}>
              <HiOutlineUsers
                onClick={() => handleViewUsers(record.clientId)}
              />
            </Tooltip>
          ) : ""}

          <Tooltip title="QR Code">
            <BsQrCode
              onClick={() =>
                showQRCode(record.clientId, record.clientName, record.name)
              }
            />
          </Tooltip>
          {authUser.clientId === null && (
            <Tooltip title="Delete">
              <RiDeleteBin5Line
                className="delete-action"
                onClick={() => deleteConfirmation(record)}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <Card
      title={
        <div
          className="client-list-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: 0,
            padding: 0,
          }}
        >
          <span style={{ margin: 0, padding: 0 }}>Clients</span>
          {!Boolean(parseInt(clientAdminId)) && (
            <Button
              type="primary"
              style={{ margin: 0 }}
              onClick={handleAddClient}
            >
              Add Client
            </Button>
          )}
        </div>
      }
    >
      <div className="client-list-search">
        <Row gutter={16} className="custom-row">
          <Col xs={24}>
            <Search
              placeholder="Search"
              value={searchDisplayText}
              allowClear
              onChange={(e) => searchClients(e.target.value)}
            />
          </Col>
        </Row>
      </div>

      <Table
        className="gx-table-responsive list-table"
        columns={columns}
        dataSource={
          debouncedSearchText?.length > 2
            ? searchClientData
            : clientData[currentPage]
        }
        loading={tableLoading}
        pagination={{
          current: currentPage,
          pageSize: 15,
          total:
            debouncedSearchText?.length > 2
              ? searchClientDataCount
              : clientCount,
          onChange: handlePagination,
        }}
      />

      {/* image slider preview */}
      <Modal
        centered
        className="QRCodeView"
        open={previewQRCode.visible}
        footer={null}
        onCancel={handleClosePreview}
        closeIcon={<MdOutlineClose />}
        width={300}
      >
        <p>
          <strong>Client Name: </strong>
          <br />
          <span
            dangerouslySetInnerHTML={{ __html: previewQRCode.clientName }}
          />
        </p>
        <p>
          <strong>Branch Name: </strong>
          <br />
          <span
            dangerouslySetInnerHTML={{ __html: previewQRCode.branchName }}
          />
        </p>
        <br />
        <center>
          <QRCode
            size={250}
            style={{ height: "auto", width: "100%" }}
            value={"https://8ii5z.app.link/" + previewQRCode.qrcodeId}
            viewBox={`0 0 256 256`}
          />
        </center>
      </Modal>
    </Card>
  );
};

export default ClientData;
